import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "../features/auth/authSlice";
import { useRefreshMutation } from "../features/auth/authApiSlice";

const decodeJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
};

// Refresh the access token 2 minutes before it expires so users editing
// documents over long sessions are never interrupted by an expired token.
const BUFFER_MS = 2 * 60 * 1000;

const useTokenRefresh = () => {
  const token = useSelector(selectCurrentToken);
  const [refresh] = useRefreshMutation();

  useEffect(() => {
    if (!token) return;

    const decoded = decodeJwt(token);
    if (!decoded?.exp) return;

    const msUntilExpiry = decoded.exp * 1000 - Date.now();
    const msUntilRefresh = msUntilExpiry - BUFFER_MS;

    if (msUntilRefresh <= 0) {
      // Already inside the buffer window — refresh immediately
      refresh().catch(() => {});
      return;
    }

    const timer = setTimeout(() => {
      refresh().catch(() => {});
    }, msUntilRefresh);

    return () => clearTimeout(timer);
  }, [token, refresh]);
};

export default useTokenRefresh;
